/**
   lock scroll of an element using overflow:hidden
   preserve gutter with scroll detection
*/
function lockScroll(element) {
  element ??= document.scrollingElement;
  if (!element) {
    return;
  }

  let scrollGap;

  //Add scroll gap if using default scrolling element
  if (element === document.scrollingElement) {
    scrollGap = Math.max(0, window.innerWidth - element.clientWidth);
  } else {
    scrollGap = element.offsetWidth - element.clientWidth;
  }
  element.style.setProperty("--scroll-gap", `${scrollGap}px`);
  element.classList.add("scroll-lock");
}

function unlockScroll(element) {
  element ??= document.scrollingElement;
  if (!element) {
    return;
  }

  element.classList.remove("scroll-lock");
  element.style.setProperty("--scroll-gap", null);
}

export default function scrollLock(lock, element = document.scrollingElement) {
  if (lock) {
    lockScroll(element);
  } else {
    unlockScroll(element);
  }
}
